import React from "react";
import { FormattedMessage } from "react-intl";

export interface IndexRow {
  labelId: string;
  pointsObtained: string | number;
  maxPoints: number;
}

export interface IndexSection {
  titleId: string;
  subtitleId: string;
  rows: IndexRow[];
  total: {
    score: string | number;
    max: number;
  };
}

interface Props {
  section: IndexSection;
  isFirst?: boolean;
}

const EqualityTable: React.FC<Props> = ({ section, isFirst }) => {
  const renderValue = (value: string | number) => {
    if (value === "NC") {
      return (
        <FormattedMessage id="page.europe.france_gender_equality_index.not.calculable" />
      );
    }
    return value;
  };

  return (
    <div className={`section ${isFirst ? "first-section" : ""}`}>
      <h2>
        <FormattedMessage id={section.titleId} />
      </h2>

      <p className="subtitle">
        <FormattedMessage
          id={section.subtitleId}
          values={{
            period: (chunks: React.ReactNode) => (
              <span className="subtitle-period">{chunks}</span>
            ),
          }}
        />
      </p>

      <div className="table-outer">
        <div className="table-wrapper">
          <table className="custom-table">
            <thead>
              <tr>
                <th></th>
                <th>
                  <FormattedMessage id="page.europe.france_gender_equality_index.table.header.points" />
                </th>
                <th>
                  <FormattedMessage id="page.europe.france_gender_equality_index.table.header.max" />
                </th>
              </tr>
            </thead>

            <tbody>
              {section.rows.map((row) => (
                <tr key={row.labelId}>
                  <td className="label-cell">
                    <FormattedMessage id={row.labelId} />
                  </td>
                  <td>{renderValue(row.pointsObtained)}</td>
                  <td>{row.maxPoints}</td>
                </tr>
              ))}

              <tr className="total-row">
                <td>
                  <FormattedMessage id="page.europe.france_gender_equality_index.index.label" />
                </td>
                <td>{renderValue(section.total.score)}</td>
                <td>{section.total.max}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default EqualityTable;
